// extracted by mini-css-extract-plugin
export default {"membershipSlide":"MembershipSlide_membershipSlide__2teHD","description":"MembershipSlide_description__1XvKo"};